// ZOD
import { HomeType, HomeZod } from '@/views/Home/HomeType';

// Strapi
import { blocks, seo } from '@/services/strapiPopulate';
import { fetchStrapiContentWithBlocks } from '@/services/blocks/fetchStrapiContentWithBlocks';

export const getHome = async (): Promise<HomeType> =>
  fetchStrapiContentWithBlocks('/api/home', HomeZod, { blocks, seo }, 'Home Page');
